import { For, type JSX } from "solid-js";
import type { IconName } from "../icon/Icon";
import { Icon } from "../icon/Icon";
import SeparatorLine from "../SeparatorLine";
import type { ClassList } from "../../types";

type FloatingToolbarProps = {
  options: {
    icon: IconName;
    ariaLabel: string;
    onClick: () => void;
  }[];
  classList?: ClassList;
};

const FloatingToolbar = (props: FloatingToolbarProps): JSX.Element => (
  <div
    class="absolute top-0 -right-9.5 z-20 rounded-sm border border-subtle bg-surface-default shadow-elevation-light-3"
    classList={props.classList}
  >
    {/* Invisible bridge to prevent hover gap */}
    <div class="absolute inset-y-0 -left-3 w-3" />

    <div class="flex w-fit flex-col gap-y-px p-0.5">
      <For each={props.options}>
        {(option, index) => (
          <>
            <ToolbarButton icon={option.icon} onClick={option.onClick} ariaLabel={option.ariaLabel} />
            {index() < props.options.length - 1 && <SeparatorLine orientation="horizontal" class="border-subtle" />}
          </>
        )}
      </For>
    </div>
  </div>
);

type ToolbarButtonProps = {
  icon: IconName;
  onClick: () => void;
  ariaLabel: string;
};

const ToolbarButton = (props: ToolbarButtonProps) => (
  <button
    title={props.ariaLabel}
    class="flex items-center justify-center rounded-sm bg-button-bg-tertiary-default p-1.5 hover:bg-button-bg-tertiary-hover focus-visible:outline-default active:bg-button-bg-tertiary-pressed"
    onClick={() => props.onClick()}
  >
    <Icon size="md" type="outline" name={props.icon} class="icon-button-icon-tertiary-soft" />
  </button>
);

export default FloatingToolbar;
